module.exports = __webpack_public_path__ + "static/graphik-regular-7bd4c44d21c9f3b35d48ca86b7546a51.woff";